import $i18n from '@/locales/i18n';
import { createCellSnippet, createRowColSnippet } from '@/common/manager/setter-snippet';
import { updateSpan } from './auto-block';
import { CELL, ROW, COL, BLOCK } from '@/common/util/const';
export const splitNodeByDimension = (dimension, node, preAppend = false) => {
    const { currentDocument } = window.parent.AliLowCodeEngine.project;
    if (!currentDocument) {
        return;
    }
    const selectedIds = currentDocument.selection.selected;
    let nodeList = [node];
    if (selectedIds.length > 1) {
        nodeList = selectedIds
            .map((id) => {
            return currentDocument.nodesMap.get(id);
        })
            .filter((_node) => !!_node);
        // 1. 类型必须完全相等，并且在同一个父元素中
        if (nodeList.some((n) => [CELL, ROW, COL].indexOf(n.componentName) === -1 || n.parent?.id !== node.parent?.id)) {
            // @ts-ignore
            window?.parent?.Next?.Message?.error($i18n.get({
                id: 'NeighboringComponentsAreRequired_320275093',
                dm: '必须相邻组件才支持快捷操作',
            }));
            return;
        }
        // 排序, nodeList是按照选中顺序展示的
        nodeList = nodeList.sort((a, b) => a.index - b.index);
        // 2. 必须连续
        const prevIndex = nodeList[0].index - 1;
        const lastIndex = nodeList[nodeList.length - 1].index;
        // 利用连续整数 n(n+1)/2 求和对比
        if (nodeList.reduce((total, n) => n.index + total, 0) !==
            (lastIndex * (lastIndex + 1)) / 2 - (prevIndex * (prevIndex + 1)) / 2) {
            // @ts-ignore
            window.parent?.Next?.Message?.error($i18n.get({
                id: 'NeighboringComponentsAreRequired_320275093',
                dm: '必须相邻组件才支持快捷操作',
            }));
            return;
        }
    }
    let parentNode = node.parent;
    let insertPoint = node;
    switch (node.componentName) {
        case CELL:
        case ROW:
        case COL:
            {
                const pComponentName = parentNode?.componentName;
                let isSameDirection = (pComponentName === ROW && dimension === 'v') ||
                    (pComponentName === COL && dimension === 'h');
                if (isSameDirection) {
                    insertPoint = preAppend ? nodeList[0] : nodeList[nodeList.length - 1];
                }
                // 需要判断下是不是全选了
                if (!isSameDirection &&
                    nodeList.length > 1 &&
                    parentNode?.children?.size === nodeList.length) {
                    const ppComponentName = parentNode.parent?.componentName;
                    isSameDirection =
                        (ppComponentName === ROW && dimension === 'v') ||
                            (ppComponentName === COL && dimension === 'h');
                    if (isSameDirection) {
                        insertPoint = parentNode;
                        parentNode = parentNode.parent;
                    }
                }
                if (isSameDirection) {
                    // 切割手法和方向一致，直接 append 节点
                    const cellSnippet = createCellSnippet();
                    const newNode = node.document?.createNode({
                        ...cellSnippet,
                        props: {
                            ...cellSnippet.props,
                            ...insertPoint.schema.props,
                            style: cellSnippet.props?.style,
                        },
                    });
                    preAppend
                        ? newNode && parentNode?.insertBefore(newNode, insertPoint, false)
                        : newNode && parentNode?.insertAfter(newNode, insertPoint, false);
                    newNode?.select();
                }
                else {
                    // 切割手法不一致，一变三节点 <ROW><CELL/><CELL/></ROW>
                    const rowcolSnippet = createRowColSnippet(dimension === 'v' ? ROW : COL);
                    const wrapSnippet = {
                        ...rowcolSnippet,
                        props: {
                            ...rowcolSnippet.props,
                            style: node.schema.props?.style,
                            width: node.schema.props?.width,
                            height: node.schema.props?.height,
                        },
                    };
                    const wrapNode = node.document?.createNode(wrapSnippet);
                    wrapNode && parentNode?.insertAfter(wrapNode, node, false);
                    if (nodeList.length > 1) {
                        // 多个子节点选中，需要先合并
                        const rowcolSnippet2 = createRowColSnippet(dimension === 'v' ? COL : ROW);
                        const wrapNode2 = node.document?.createNode(rowcolSnippet2);
                        wrapNode2 && parentNode?.insertAfter(wrapNode2, node, false);
                        nodeList.forEach((n) => wrapNode2?.insertAfter(n));
                        wrapNode2 && wrapNode?.insertAfter(wrapNode2);
                        if (wrapNode2) {
                            insertPoint = wrapNode2;
                        }
                    }
                    else {
                        // node 的宽度要去掉
                        node.setPropValue('style', undefined);
                        wrapNode?.insertAfter(node, wrapNode, false);
                    }
                    const cellSnippet = createCellSnippet();
                    const newNode = node.document?.createNode({
                        ...cellSnippet,
                        props: {
                            ...cellSnippet.props,
                            ...insertPoint.schema.props,
                            style: cellSnippet.props?.style,
                            width: undefined,
                            height: undefined,
                        },
                    });
                    preAppend
                        ? newNode && wrapNode?.insertBefore(newNode, insertPoint, false)
                        : newNode && wrapNode?.insertAfter(newNode, insertPoint, false);
                    newNode?.select();
                }
            }
            break;
        case BLOCK:
            if (dimension === 'v') {
                updateSpan({
                    parent: node.parent,
                    child: node,
                    type: 'split',
                });
            }
            node.select();
            break;
        default:
            break;
    }
};
